module.exports = __webpack_public_path__ + "img/bg1-right-side.3f0a9f72.svg";